var _Path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgIconBenchOutline(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    clipRule: "evenodd",
    d: "M22.578 12.37l3.218-5.36a1.987 1.987 0 10-3.408-2.046l-6.959 11.589H5.988a1.987 1.987 0 000 3.975h7.545v1.209h-.47L8.67 27.292H7.523v1.899h5.081v-1.9h-1.4l2.821-3.567h1.228l9.512 3.568h-.836v1.899H29v-1.9h-1.39L22.578 12.37zm-7.057 9.367v-1.21h2.158l3.58-5.962 3.895 10.75-9.633-3.578z"
  })));
}

export default SvgIconBenchOutline;